import { useMediaQuery, useTheme } from "@mui/material";
export const useMediaQueryForMobile = () => {
  const theme: any = useTheme();
  return useMediaQuery(theme.breakpoints.down("sm"));
};
